import axios, { postJson } from '@dap/shared-utils/http.js';

export default {
    // 获取N合一列表（广告类型、游戏、市场、区域）
    getConfigInfo (params = {}) {
        return axios.get('/coach/api/game_ad_type', { params });
    },

    // 获取基础信息列表 新版本(游戏市场区域)
    getBaseConfig (params = {}) {
        return axios.get('/coach/api/top_bar_filter_options', { params });
    },

    // 获取渠道列表
    getChannelList (params = {}) {
        return axios.get('/coach/api/cpe_spreader', { params });
    },

    // 获取投放平台列表
    getSpreaderList (params = {}) {
        return axios.get('/coach/api/spreader', { params });
    },

    // 获取主表数据
    getMainTableList (menu, mainName, params = {}) {
        return axios.get(`/dapper/api/insights/${menu}/${mainName}`, {
            params,
        });
    },

    // 获取子表数据
    getSubTableList (menu, mainName, subName = 'day', params = {}) {
        return axios.get(`/dapper/api/insights/${menu}/${mainName}/${subName}`, { params });
    },

    // 获取高级筛选 各维度列表
    getValueList (name, params = { page: 1, per_page: 10 }, isFromCelebrity = false, isGet = false) {
        const url = isFromCelebrity ? '/dapper/api/mansion/' : '/coach/api/';
        if (isFromCelebrity || isGet) {
            return axios.get(`${url}${name}`, { params });
        } else {
            return axios.post(`${url}${name}`, params);
        }
    },

    getBenchMark (params = {}) {
        return axios.get('/dapper/api/insights/benchmark', { params });
    },

    // 获取海外投放平台列表（google、facebook）
    getSpreadPlatformList (params = {}) {
        // has_thirdparty = 1 表示海外
        const combinedParams = Object.assign(
            {
                has_thirdparty: 1,
                page: 1,
                per_page: 100,
            },
            params
        );
        return axios.get('/coach/api/spreader', { params: combinedParams });
    },

    // 获取海外投放平台下的账户列表
    getAccountList (params = {}) {
        const combinedParams = Object.assign(
            {
                page: 1,
                per_page: 100,
            },
            params
        );
        return axios.get('/coach/api/ad_accounts', { params: combinedParams });
    },

    // 获取自定义列的列表
    getCustomColumnList (routePath = '', params = {}) {
        return axios.get(routePath, { params });
    },

    // 更新自定义列的顺序和个数
    updateCustomColumnList (routePath = '', params = {}) {
        return axios.post(routePath, params);
    },

    // 观星台 字典
    getObservatoryDict (params = {}) {
        return axios.get('/dapper/api/insights/observatory/dict', { params });
    },

    // 日期标注类型列表
    getCommentTypes (params = {}) {
        return axios.get('/dapper/api/com/comment_type', { params });
    },

    // 工作表日期批注
    getTableCommentTypes (params = {}) {
        return axios.get('/dapper/api/com/table/common', { params });
    },

    // 获取所有用户列表
    getUserList (params = {}) {
      params.status = 1;
      return axios.get('/coach/api/dap_user_id', { params });
  },

    // 获取所有商主列表
    getMasterRegionList (params = {}) {
        return axios.get('/coach/api/master_region', { params });
    },
    // new 获取所有商主列表
    getMasterList (params = {}) {
        return axios.get('/coach/api/master', { params });
    },

    // 获取广告首页 字典
    getAd2Dict (params = {}) {
        return axios.get('/dapper/api/ad2/dict', { params });
    },

    //获取素材字典
    getMaterialDictData (params = {}) {
        return axios.get('/dapper/api/materiel_2/dict', { params });
    },

    // 获取facebook创意字典
    getCreativeFacebookDict (params = {}) {
        return axios.get('/dapper/api/creative2/fb/seletor', { params });
    },
    // 获取扳手系统引导
    getSystemGuideStatus (params = {}) {
        return axios.get('/dapper/api/help_center/guide', { params });
    },
    // 更新扳手系统引导
    setSystemGuideStatus (params = {}) {
        return axios.post('/dapper/api/help_center/guide', params);
    },

    sendScreen (params = {}) {
        return axios.post('/dapper/api/screen', params);
    },

    // 获取监控配置列表
    getMonitorList (params = { is_all: 1 }) {
        return axios.get('/coach/api/monitor/config', { params });
    },
    getStsToken () {
        return postJson('/artascope/api/sts', {});
    },

    // 获取投放抖音号
    getDouYinMaster(params = {}){
        return axios.get('/coach/api/ies_core_user', { params })
    },

    // 工作表-获取自定义筛选信息
    getInsightFilter (params = {}) {
      return axios.get('/dapper/api/insights/worksheet_filter/query', { params })
    },

    // 工作表-设置自定义筛选信息
    setInsightFilter (params = {}) {
      return axios.post('/dapper/api/insights/worksheet_filter/update', params)
    },

    // 退出登录
    logout () {
      return axios.get('/user/api/user/logout');
    }
};
